import { DateTime } from 'luxon';

const __defaultOptions = {
    showInit: false,
    endDay: '2026-04-14T00:00:00',
    selectors: {
        counter: '.countdown',
    },
};

export default class CountDown {
    constructor(options) {
        this.options = Object.assign({}, __defaultOptions, options);

        if (this.options.showInit) {
            console.info('counter:init', this.options);
        }

        const countdownElements = document.querySelectorAll(this.options.selectors.counter);
        if (countdownElements.length > 0) {
            countdownElements.forEach((counter) => {
                this.endDay = DateTime.fromISO(counter.getAttribute('data-end-day') || this.options.endDay, { zone: 'Europe/Berlin' });

                // Update the count immediately to prevent 1s delay
                this.updateCounter(counter);

                // Store interval ID on the counter element
                counter._countdownInterval = setInterval(() => this.updateCounter(counter), 1000);
            });
        }
    }

    updateCounter = (counter) => {
        // Only use days, hours, minutes, seconds
        const diffUnits = ['days', 'hours', 'minutes', 'seconds'];
        let diff = this.endDay.diff(DateTime.now().setZone('Europe/Berlin'), diffUnits);
        const totalSeconds = Math.floor(diff.as('seconds'));

        if (totalSeconds <= 0) {
            // Clear the interval if it exists
            if (counter._countdownInterval) {
                clearInterval(counter._countdownInterval);
                counter._countdownInterval = null;
            }
            counter.style.display = 'none';
            document.querySelector('.countdown-alternative-text')?.classList.remove('d-none');
            return;
        }
        counter.querySelector('[data-id="countdownDays"]').innerHTML = diff.days.toString().padStart(2, '0');
        counter.querySelector('[data-id="countdownHours"]').innerHTML = diff.hours.toString().padStart(2, '0');
        counter.querySelector('[data-id="countdownMinutes"]').innerHTML = diff.minutes.toString().padStart(2, '0');
        counter.querySelector('[data-id="countdownSeconds"]').innerHTML = Math.round(diff.seconds).toString().padStart(2, '0');
        counter.setAttribute('data-counter', Math.round(diff.seconds).toString());
    };
}
